import { render, staticRenderFns } from "./addWeekSchedule.vue?vue&type=template&id=59c8c9ae"
import script from "./addWeekSchedule.vue?vue&type=script&lang=js"
export * from "./addWeekSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports